import { render } from "./AppDownloadButton.vue?vue&type=template&id=f4323ae8&scoped=true"
import script from "./AppDownloadButton.vue?vue&type=script&lang=js"
export * from "./AppDownloadButton.vue?vue&type=script&lang=js"

import "./AppDownloadButton.vue?vue&type=style&index=0&id=f4323ae8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4323ae8"]])

export default __exports__